import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from './../global';
import { Email } from './email.model';
import { CurrentUser } from '../shared/user.model';
import { Observable } from 'rxjs/Observable';
import { User } from './user.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClientSecured } from './http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _registerUrl = myGlobals.baseApi + '/webadmin/v1/user';
  private _loginUrl = myGlobals.baseApi + '/webadmin/v1/login';
  private _currentUserUrl = myGlobals.baseApi + '/webadmin/v1/user/by-email';
  private userLoggedIn = new BehaviorSubject(this.isLoggedIn());

  private currentUser: any = null;
  public isAdmin: any = null;
  // private currentUser: CurrentUser;

  constructor(private http: HttpClientSecured, private router: Router) {}

  registerUser(user) {
    return this.http.post<any>(this._registerUrl, user);
  }

  loginUser$(user: User): Observable<any> {
    console.log('AuthService: loginUser: user: ', JSON.stringify(user));
    localStorage.setItem('loginUserData', JSON.stringify(user));
    const emailData: Email = {
      email: user.email
    };
    this.getCurrentUser$(emailData).subscribe(
      data => {
        console.log('AuthService: loginUser: currentUser: ', data);
        localStorage.setItem('currentUser', JSON.stringify(data));
      },
      error => console.log('AuthService: error: ', error)
    );
    return this.http.post<any>(this._loginUrl, user);
  }

  logoutUser(): void {
    console.log('AuthService: logoutUser: Saliendo');
    localStorage.clear();
    this.router.navigate(['/']);
    this.setLoggedIn(false);
  }

  getCurrentUser$(email: Email) {
    console.log('AuthService: getCurrentUser: email: ', JSON.stringify(email));
    return this.http.post<CurrentUser>(this._currentUserUrl, email);
  }

  isLoggedIn() {
    let res = false;
    if (localStorage.getItem('sessionToken')) {
      res = true;
    }
    return res;
  }

  getObservableLoggedIn(): Observable<boolean> {
    console.log('getObservableLoggedIn:' + this.userLoggedIn.getValue());
    return this.userLoggedIn.asObservable();
  }

  setLoggedIn(val: boolean) {
    console.log('setLoggedIn:' + val);
    this.userLoggedIn.next(val);
  }

  getToken() {
    return localStorage.getItem('sessionToken');
  }
}
